import { ContractHoardings } from "../contracts/contract-hoarding";
import { HoardingGroup } from "../hoardings/hoardings-group";

export class ConflictHoarding {
    hoarding: ContractHoardings = new ContractHoardings();
    hoardingGroups: HoardingGroup[] = [];
}
